module.exports = __webpack_public_path__ + "static/img/banner_d.85da560.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_d.jpg
// module id = wyEF
// module chunks = 1